import { render } from "./Product Sales.vue?vue&type=template&id=330b1dd2"
import script from "./Product Sales.vue?vue&type=script&lang=js"
export * from "./Product Sales.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__